module.exports = __webpack_public_path__ + "static/stiftelsen-allmanna-barnhuset-779921aa4972f51c8da50f3f65b37627.png";